<ion-header>
  <ion-toolbar>
    <ion-title>{{ name() }}</ion-title>
    <ion-button slot="end" fill="clear" (click)="dismiss()" [attr.aria-label]="'common.close' | translate">
      <ion-icon slot="icon-only" name="close"></ion-icon>
    </ion-button>
  </ion-toolbar>
</ion-header>

<ion-content class="od-content">
  <div class="od-stack">
    <ion-card class="od-hero-card">
      <ion-card-content>
        @if (name()) {
        <p class="od-hero-caption">{{ name() }}</p>
        }
        @switch (resultType()) { @case ("value") {
        <p class="od-result-value">{{ result() }}</p>
        } @case ("boolean") {
        <div class="od-result-boolean">
          @if (booleanSuccess()) {
          <ion-icon
            color="success"
            name="checkmark-circle-outline"
            class="od-result-icon"
          ></ion-icon>
          } @else {
          <ion-icon
            color="danger"
            name="close-circle-outline"
            class="od-result-icon"
          ></ion-icon>
          }
          <p class="od-result-boolean-label">{{ result() }}</p>
        </div>
        } }
      </ion-card-content>
    </ion-card>

    <ion-card class="od-card">
      <ion-card-header>
        <ion-card-title>{{ 'operations.detail.formula' | translate }}</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        <div class="od-expression">
          <re-operation-render
            [fragments]="originalParsed()"
            [finalFragments]="finalParsed()"
          ></re-operation-render>
        </div>
      </ion-card-content>
    </ion-card>

    @if (allChaosResult().named.length) {
    <ion-card class="od-card">
      <ion-card-header>
        <ion-card-title>{{ 'operations.detail.chaosApplied' | translate }}</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        @for (op of allChaosResult().named; let i = $index; track i) {
        <div class="od-detail-row">
          <span class="od-detail-name">{{ op.name }}</span>
          <ion-note class="od-detail-value">{{ op.roll.output }}</ion-note>
        </div>
        }
      </ion-card-content>
    </ion-card>
    } @if (allStatSelected().length) {
    <ion-card class="od-card">
      <ion-card-header>
        <ion-card-title>{{ 'operations.detail.statsSelected' | translate }}</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        @for (op of allStatSelected(); let i = $index; track i) {
        <div class="od-stat-block">
          <p class="od-stat-title">{{ op.name }}</p>
          <div class="od-stat-rows">
            <div class="od-stat-row">
              <span class="od-stat-key">{{ 'operations.detail.from' | translate }}</span>
              <div class="od-chips">
                @for (stat of op.unselected; track $index) {
                <ion-chip class="od-chip">{{ stat }}</ion-chip>
                }
              </div>
            </div>
            <div class="od-stat-row">
              <span class="od-stat-key">{{ 'operations.detail.choice' | translate }}</span>
              <div class="od-chips">
                @for (stat of op.selected; track $index) {
                <ion-chip class="od-chip od-chip--accent">{{ stat }}</ion-chip>
                }
              </div>
            </div>
            <div class="od-stat-row">
              <span class="od-stat-key">{{ 'operations.detail.result' | translate }}</span>
              <div class="od-chips">
                <ion-chip class="od-chip od-chip--result">{{ op.result }}</ion-chip>
              </div>
            </div>
          </div>
        </div>
        }
      </ion-card-content>
    </ion-card>
    } @if (allInserted().length) {
    <ion-card class="od-card">
      <ion-card-header>
        <ion-card-title>{{ 'operations.detail.insertedValues' | translate }}</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        @for (op of allInserted(); let i = $index; track i) {
        <div class="od-detail-row">
          <span class="od-detail-name">{{ op.name }}</span>
          <ion-note class="od-detail-value">{{ op.value }}</ion-note>
        </div>
        }
      </ion-card-content>
    </ion-card>
    }
  </div>
</ion-content>
